<template>
	<div class="serivce">
		<h1>佣金介绍</h1>
		<p>
			1、收费说明：<br>
			基于平台向客户提供了信息资源展示，线上竞价交易等软件服务，平台收取相关软件服务费用。<br>
			2、收费条件：<br>
			以系统成交为准，即只要标的通过系统网络竞价流程成交，竞买人应按照本规则规定的收费比例缴纳软件服务费。<br>
			3、不收费情形：<br>
			系统交易失败的情形，包括流拍，撤回，终止，成交不卖的情形。<br>
			4、收费标准：<br>
			依据《中华人民共和国拍卖法》的规定，买受人在竞拍成功后，需根据拍品详情页中关于拍卖服务费的收取约定，缴纳约定比例的拍卖服务费。其中：系统成交价=起拍价+溢价。<br>
			5、缴费方式：<br>
			当竞拍人竞拍成功后，在“我的订单”中系统提示应该缴费的金额，“确认并缴费”之后，通过线下支付将款项转入平台指定的银行账户。<br>
			6、缴费期限：<br>
			订单生成之日起3天之内，买受人逾期未全额缴纳的，平台可对其进行依法追缴。<br>
			7、申请发票：<br>
			买受人可依据缴费的凭据向平台方申请开具服务费发票。</p>
		<!-- <span @click="goBack">返回></span> -->
	</div>
</template>

<script>
export default {
	metaInfo: {
		title: "拍界——唤醒您的沉睡资产",
		meta: [{
			name: "keywords",
			content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
		}, {
			name: "description",
			content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
		}]
	},
	methods:{
		goBack: function (){
			this.$router.go(-1)
		}
	}
}
</script>